export default __webpack_public_path__ + "static/media/forestly-expl-nn-03_DE.41d518df.png";